var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79175 3.60938C7.79175 3.84144 7.88394 4.064 8.04803 4.22809C8.21212 4.39219 8.43468 4.48438 8.66675 4.48438C8.89881 4.48438 9.12137 4.39219 9.28547 4.22809C9.44956 4.064 9.54175 3.84144 9.54175 3.60938C9.54175 3.37731 9.44956 3.15475 9.28547 2.99066C9.12137 2.82656 8.89881 2.73438 8.66675 2.73438C8.43468 2.73438 8.21212 2.82656 8.04803 2.99066C7.88394 3.15475 7.79175 3.37731 7.79175 3.60938ZM7.79175 7.98438C7.79175 8.21644 7.88394 8.439 8.04803 8.60309C8.21212 8.76719 8.43468 8.85938 8.66675 8.85938C8.89881 8.85938 9.12137 8.76719 9.28547 8.60309C9.44956 8.439 9.54175 8.21644 9.54175 7.98438C9.54175 7.75231 9.44956 7.52975 9.28547 7.36566C9.12137 7.20156 8.89881 7.10938 8.66675 7.10938C8.43468 7.10938 8.21212 7.20156 8.04803 7.36566C7.88394 7.52975 7.79175 7.75231 7.79175 7.98438ZM7.79175 12.3594C7.79175 12.5914 7.88394 12.814 8.04803 12.9781C8.21212 13.1422 8.43468 13.2344 8.66675 13.2344C8.89881 13.2344 9.12137 13.1422 9.28547 12.9781C9.44956 12.814 9.54175 12.5914 9.54175 12.3594C9.54175 12.1273 9.44956 11.9048 9.28547 11.7407C9.12137 11.5766 8.89881 11.4844 8.66675 11.4844C8.43468 11.4844 8.21212 11.5766 8.04803 11.7407C7.88394 11.9048 7.79175 12.1273 7.79175 12.3594Z",
    fill: "#262626"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.d6268b3a605ac5e4793a0a05edf020b4.svg";
export { ForwardRef as ReactComponent };